import axios from 'axios'
const isProduction = process.env.NODE_ENV === 'production';
const config={
    baseURL: isProduction ? process.env.VUE_APP_API: process.env.VUE_APP_TEST,
    timeout: 10000
  }

async function get(url,data){
    config['url']=url
    config['headers']={'Content-Type':'application/json'}
    config['method']='get'
    const result=await axios.post(url,JSON.stringify(data),config)
    return result.data
}

async function post(url,data){
    config['url']=url
    config['headers']={'Content-Type':'application/json'}
    config['method']='post'
    const result=await axios.post(url,JSON.stringify(data),config)
    return result.data
}

function download(url,data){
    const target=process.env.VUE_APP_API+url+'?nums='+data.nums+'&type='+data.type+'&month='+data.month+'&code='+data.code+'&expire='+data.expire
    window.location.href=target
}
export {get,post,download} 